import { render } from "./ComparativeParticipantsBreakdown.vue?vue&type=template&id=2d3da08f"
import script from "./ComparativeParticipantsBreakdown.vue?vue&type=script&lang=js"
export * from "./ComparativeParticipantsBreakdown.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__